import { apiPost } from "../baseApi";

export const signupVerify = async (data) => {
  try {
    const response = await apiPost("_signupVerify", data);
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
